import { ChangeDetectionStrategy, Component, Input, Output, OnInit, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { Assessor } from 'src/app/models/Assessor';
import { AssessorData } from 'src/app/models/AssessorData';

@Component({
  selector: 'app-assessors-unseal',
  templateUrl: 'assessors-unseal.component.html',
  styleUrls: ['./assessors-unseal.component.less', '../../../shared/common.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class AssessorsUnsealComponent implements OnInit, OnChanges {
  @Input() isValidated: boolean = false;
  @Input() assessors: Array<Assessor> = [];
  @Input() remainingAssessors = 0;
  @Input() unsealedAssessors: Array<AssessorData> = [];

  @Output() updateAssessorEvent = new EventEmitter();
  @Output() relaunchAssessorEvent = new EventEmitter();
  @Output() inviteAssessorsEvent = new EventEmitter();
  isExpanded: boolean = true;
  unsealedEmails = new Set<string>();

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  hasUnsealed(assessor: Assessor): boolean {
    return this.unsealedEmails.has(assessor.email);
  }

  private computeUnsealedEmails(): void {
    this.unsealedEmails = new Set(this.unsealedAssessors.map(a => a.email));
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['unsealedAssessors']) {
      this.computeUnsealedEmails();
    }
  }

  ngOnInit(): void {
    
    this.computeUnsealedEmails();
    // this.isValidated = this.assessors.length - this.unsealedAssessors.length >= Math.ceil(this.assessors.length / 2);
  }
}
